import { DimensionKeys } from '../../middleware/google-analytics';
import { getProfilePageParameters } from '../state/selectors';
import isZocdocBrand from '../../utils/isZocdocBrand';

const getPractice = provider => {
    const practice = provider.practices.length > 0
        ? provider.practices[0]
        : null;

    return practice ? `${practice.monolithId}: ${practice.name}` : null;
};

const getActiveStatus = provider => {
    if (provider.isApproved && provider.isBookable) {
        return 'Professional Active';
    } else {
        return 'Professional Inactive or Preview';
    }
};

const getSpecialty = provider => {
    const specialty = provider.relevantSpecialty;
    return specialty ? `${specialty.id}: ${specialty.name}` : null;
};

const analytics = {
    rollUpBucket: () => 'Profile',
    pageType: () => 'Profile',

    createCustomDimensionsFromProvider(provider) {
        return [
            {
                dimension: DimensionKeys.Specialty,
                value: getSpecialty(provider),
            },
            {
                dimension: DimensionKeys.Professional,
                value: `${provider.monolithId}: ${provider.nameInSentence}`,
            },
            {
                dimension: DimensionKeys.Provider,
                value: getPractice(provider),
            },
            {
                dimension: DimensionKeys.ProfessionalActiveStatus,
                value: getActiveStatus(provider),
            },
        ];
    },

    createEventData(provider, theme) {
        const category = isZocdocBrand(theme.directoryId) ? 'Zocdoc' : 'White Label';
        const action = provider.isApproved && provider.isBookable
            ? 'Viewed Bookable Profile'
            : 'Viewed Non-Bookable Profile';

        return [{
            category,
            action,
        }];
    },

    createPageCategory(provider) {
        if (provider.isPreview) {
            return 'ProfilePreviewProfessional';
        } else if (provider.isApproved && provider.isBookable) {
            return 'ProfileActiveProfessional';
        } else {
            return 'ProfileChurnedProfessional';
        }
    },

    // set up during fetchData so we don't have duplicate review data in the redux store and apollo cache
    pageCategory: state => getProfilePageParameters(state).pageCategory,
    pageSpecificCustomDimensions: state => getProfilePageParameters(state).customDimensions,
    getEventData: ({ state }) => getProfilePageParameters(state).eventData,
};

export default analytics;
